export const replaceEntityById = <T extends { id: any }>(updatedEntity: T, list: T[]): T[] => {
  return list.map(entity => (entity.id === updatedEntity.id) ? updatedEntity : entity)
}

export const deleteEntityById = <T extends { id: any }>(entityId: any, list: T[]): T[] => {
  return list.filter(entity => entity.id !== entityId)
}